import styled from 'styled-components'
import Icon from '@ui/icons'

const Title = styled('div')`
  text-align: center;
  font-size: 2rem;
`

const BrandName = styled('h2')`
  font-weight: 300;
`

const Container = styled('div')`
  color: var(--white);
  background-image: linear-gradient(156.23deg, var(--brand) 4.93%, #2b74b5 96.05%);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`

const Logo = styled(Icon)`
  height: 100px;
  margin: var(--space-6) 0;
  width: 100px;
  text-align: center;
`

export default {
  Container,
  Title,
  Logo,
  BrandName,
}
